export const mapboxAccessToken =
  "pk.eyJ1Ijoic2hpa2hhci0yODE3IiwiYSI6ImNra2RpNDc3ZjBiaTkycG55ZGdjMWU5emEifQ.XHIfGpCi-NiNfKf09mZF9w";
export const openweathermapKey = "bee0b4a676e5cc914c650a3e4c5320f0";
// export const darkSkyKey = '6cff08614ea11d65fe5755991d4b3e0a';
export const newsApiKey = "3c3d76c7d35f480c90bdb0843a2bcc84";
export const ambeeApiKey = "cnQyKb1dIA4r3qVu9zfWK6C2V9drddyY4kax84mE";
export const weatherApiKey = "6459f7d71c8942b09d300930230407";
